module.exports = __webpack_public_path__ + "static/media/managua2.b73f241f.jpg";